export default {
  get_all: { method: "get", url: "api/municipality-indicators" },
  show: { method: "get", url: "api/municipality-indicators{/id}" },
  store: { method: "post", url: "api/municipality-indicators" },
  update: { method: "put", url: "api/municipality-indicators{/id}" },
  delete: { method: "delete", url: "api/municipality-indicators{/id}" }
};
